import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import MBOTColorLogo from "../../assets/authentication/MBOTColorLogo.png";
import EmailSent from "../../assets/authentication/EmailSent.png";
import { resendEmail } from "../../redux/slices/authSlice";
import "./EmailVerification.css";

const EmailVerification = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const resendLoading = useSelector((state) => state.auth.resendLoading);

    // Extracting values from route state
    const name = location?.state?.name;
    const email = location?.state?.email;

    // useEffect to check if 'name' and 'email' are present in the route state
    useEffect(() => {
        if (!name || !email) {
            navigate("/");
        }
    }, [name, email]);

    // Handles the Resend button click
    const handleResendEmail = () => {
        const data = { email: email };
        dispatch(resendEmail({ data, navigate }));
    };

    return (
        // Container for the email verification screen
        <div className="bg-blue-10 email-verification-outer-container center-alignment">
            {/* White background container for the email verification content */}
            <div className="email-verification-inner-container m-2 center-alignment flex-column">
                {/* MBOTColorLogo */}
                <img src={MBOTColorLogo} alt="MBOT Logo" className="mbot-color-logo" />
                {/* EmailSent image */}
                {/* <img src={EmailSent} alt="Email Sent" className="email-verification-img img-fluid" /> */}

                {/* Section containing text content for email verification */}
                <section className="text-center" style={{ marginTop: "70px" }}>
                    {/* Header section with email verification title */}
                    <header>
                        <h5 className="text-primary-sapphire fw-600 fs-25">{t("COMMON.EMAIL.VERIFICATION")}</h5>
                        {/* Subtitle with the user's name and thank you message */}
                        {/* <h6 className="fw-600 fs-20 text-gray-900 subtitle">
              Hey {name}, thanks for registering with us
            </h6> */}
                    </header>

                    {/* Main content with information about the account creation and email confirmation */}
                    <main className="text-gray-250 fw-500 fs-18">
                        Your account has been successfully created.
                        <br /> A confirmation to activate your account has been sent <br /> to the email address <span className="fw-700">{email}</span>.
                    </main>

                    {/* Footer with a link to resend the email verification */}
                    <footer className="fs-20 fw-500 footer text-gray-900">
                        Didn’t receive email?{/*  */}
                        <button className="fw-500 auth-resend-btn text-primary-sapphire" onClick={handleResendEmail} disabled={resendLoading}>
                            {resendLoading ? <span className="secondary-loader"></span> : "Resend"}
                        </button>
                    </footer>
                </section>
            </div>
        </div>
    );
};

export default EmailVerification;
